export default "3a7109b";



// WEBPACK FOOTER //
// ./src/version.ts